import Vue from 'vue'
import Vuex from 'vuex'

export default class {
    constructor() {
        Vue.use(Vuex);
        const state = {
			config: null,
			loading: true,
	        invoiceError: null,
	        invoices: [],
	        paymentDetails: null,
	        processingPayment: false,
		};
        const getters = {
			config: state => state.config,
			loading: state => state.loading,
	        invoices: state => state.invoices,
	        invoiceError: state => state.invoiceError,
	        processingPayment: state => state.processingPayment,
	        paymentDetails: state => state.paymentDetails,
		};
        const mutations = {
			setStateValue(state, payload) {
				state[payload.key] = payload.value;
			},
	        addDataRow (state, payload) {
		        state[payload.key].push(payload.value)
	        }
		};
        const actions = {
        	resetInvoiceError() {
		        commit("setStateValue", { key: 'invoiceError', value: null })
	        },
			async loadConfig({commit}, payload) {
				await fetch(payload)
					.then(res => res.json())
					.then(data => {
						commit("setStateValue", { key: 'config', value: data })
						commit("setStateValue", { key: 'loading', value: false })
					})
					.catch(err => {
						console.error(err)
					})
			},
	        async fetchInvoice({commit}, { payload, data}) {
				
		        await fetch(payload, {
				        method: 'POST',
				        headers: { 'Content-Type': 'application/json' },
				        body: JSON.stringify(data),
		            })
			        .then(async res => {
						const respData = await res.json();
						switch (res.status) {
							case 200:								
								console.log("FetchInvoice: "+respData);
								commit("setStateValue", { key: 'invoiceError', value: null });
								commit('addDataRow', { key: 'invoices', value: respData });
								break;
							case 409:	
								var incDataJson = JSON.parse(JSON.stringify(data));							
								console.log("FetchInvoice: "+incDataJson.invoiceNumber);
								commit("setStateValue", { key: 'invoiceError', value: "Invoice #"+incDataJson.invoiceNumber+" is not available for online payment. Please reach out to us at <a href='mailto:ar@lexitaslegal.com'>ar@lexitaslegal.com</a> for personal assistance." });
								break;
							default:
								commit("setStateValue", { key: 'invoiceError', value: 'Unable to find the invoice' })
								
						}						
					})
					.catch(err => {
						commit("setStateValue", { key: 'invoiceError', value: err})
					})			        
	        },
	        async payInvoice({commit}, { payload, data }) {
		        commit('setStateValue', { key: 'paymentDetails', value: null })
		        commit("setStateValue", { key: 'processingPayment', value: true })

		        await fetch(payload, {
			        method: 'POST',
			        headers: { 'Content-Type': 'application/json' },
			        body: JSON.stringify(data),
		        })
			        .then(res => res.json())
			        .then(data => {
			        	let _data = data
				        let errorCodes = ["2", "3", "4", "27", "44", "45", "65", "250", "251", "254"]
			        	if (_data === 'Unable to perform the operation') {
					        _data = {
						        isSuccessful: false,
						        error: 'Invalid Credit Card Number'
					        }
				        } else if (typeof _data === 'object') {
			        		let code = _data.authorizeNetResponse.transactionResponse.responseCode;
			        		let invalidCVV = _data.authorizeNetResponse.transactionResponse.cvvResultCode === 'N';
			        		if (code && errorCodes.includes(code)) {
						        _data = {
							        isSuccessful: false,
							        error: invalidCVV ? 'Invalid CVV' : 'Invalid Credit Card Number'
						        }
					        } else if (_data.status < 200 || _data.status > 299) {
						        _data = {
							        isSuccessful: false,
							        error: 'genericError'
						        }
					        }
				        }
				        commit('setStateValue', { key: 'paymentDetails', value: _data })
				        commit("setStateValue", { key: 'processingPayment', value: false })
			        })
			        .catch(err => {
						let _data = data;
						_data = {
							isSuccessful: false,
							error: 'Sorry an error occurred. Check Card #, CVV and Expiration Date and try again.'
						}
						commit('setStateValue', { key: 'paymentDetails', value: _data })
						commit("setStateValue", { key: 'processingPayment', value: false })
			        })
	        },
	        async savePaymentData({commit}, { payload, data }) {
		        await fetch(payload, {
			        method: 'POST',
			        headers: { 'Content-Type': 'application/json' },
			        body: JSON.stringify(data),
		        })
			        .then(res => res.json())
			        .then(data => {

			        })
			        .catch(err => {
				        console.error(err)
			        })
	        },
	        async resetData({commit}) {
		        commit('setStateValue', { key: 'paymentDetails', value: null })
		        commit("setStateValue", { key: 'processingPayment', value: false })
		        commit("setStateValue", { key: 'invoices', value: [] })
	        }
		};

        this.store = new Vuex.Store({
            state,
            getters,
            mutations,
            actions
        });
    }
}